// Browser half of the analytics vocabulary. The Ruby half is app/lib/analytics.rb,
// which is also the allowlist the server checks — an event name that drifts
// out of sync here is silently dropped on arrival, so
// test/lib/analytics_js_parity_test.rb asserts the two lists stay identical.
//
// Only the browser-only events live here: the shelf (which exists purely in
// localStorage) and the two book-page interactions that never reach the
// server — the WhatsApp CTA opens wa.me, and Compartilhar is a Web Share /
// clipboard call. Page views, book views and catalog searches are recorded
// server-side, where they can't be blocked or forged.
import ahoy from "ahoy.js"

ahoy.configure({
  // Mirrors config/initializers/ahoy.rb: `Ahoy.cookies = :none` means no
  // tracking cookie is written on either side, and the server opens the visit
  // itself on the page request, so there is nothing to POST to /ahoy/visits.
  cookies: false,
  trackVisits: false
})

export const SHELF_ADD = "Shelf add"
export const WHATSAPP_ORDER = "WhatsApp order"
export const BOOK_WHATSAPP = "Book WhatsApp"
export const BOOK_SHARE = "Book share"

// ahoy.js swallows network failures on its own, but a throttled response or a
// blocking extension must never take the shelf down with it — measuring a
// purchase is not worth risking one.
export function track(name, properties) {
  try {
    ahoy.track(name, properties)
  } catch {
    // ignored on purpose
  }
}
